var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamCase4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_850_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9785 49.9907C52.9785 49.3146 53.247 48.6663 53.7251 48.1882C54.2031 47.7102 54.8515 47.4416 55.5276 47.4416C56.2036 47.4416 56.852 47.7102 57.33 48.1882C57.8081 48.6663 58.0766 49.3146 58.0766 49.9907V61.385L61.161 61.7164L73.7534 67.2988C75.1044 67.9106 75.9201 69.2616 75.9201 70.7401V81.854C75.8436 83.9442 74.1867 85.6011 72.0965 85.6776H55.5276C54.5589 85.6776 53.6412 85.2953 52.9785 84.5815L40.4881 73.8754L42.3744 71.9127C42.8587 71.3774 43.5469 71.097 44.2607 71.097H44.8215L52.9785 75.4813V49.9907ZM55.5276 39.7944C58.2318 39.7944 60.8252 40.8687 62.7374 42.7808C64.6496 44.693 65.7238 47.2865 65.7238 49.9907C65.7238 53.8143 63.6846 57.0516 60.6257 58.8105V55.7006C62.1806 54.2986 63.1748 52.2594 63.1748 49.9907C63.1748 47.9625 62.3691 46.0174 60.9349 44.5833C59.5008 43.1492 57.5557 42.3435 55.5276 42.3435C53.4994 42.3435 51.5543 43.1492 50.1202 44.5833C48.686 46.0174 47.8804 47.9625 47.8804 49.9907C47.8804 52.2594 48.8745 54.2986 50.4294 55.7006V58.8105C47.3705 57.0516 45.3313 53.8143 45.3313 49.9907C45.3313 47.2865 46.4055 44.693 48.3177 42.7808C50.2299 40.8687 52.8233 39.7944 55.5276 39.7944ZM55.5276 34.6963C59.5839 34.6963 63.4741 36.3077 66.3423 39.1759C69.2106 42.0442 70.8219 45.9344 70.8219 49.9907C70.822 54.3241 69.0121 58.2242 66.1317 61.0281L63.5826 59.8811C66.4376 57.5359 68.2729 53.9672 68.2729 49.9907C68.2729 46.6104 66.9301 43.3686 64.5399 40.9784C62.1496 38.5882 58.9078 37.2454 55.5276 37.2454C52.1473 37.2454 48.9055 38.5882 46.5152 40.9784C44.125 43.3686 42.7822 46.6104 42.7822 49.9907C42.7822 55.2163 45.9176 59.7026 50.4294 61.6654V64.4184C44.4901 62.3027 40.2332 56.6437 40.2332 49.9907C40.2332 45.9344 41.8445 42.0442 44.7128 39.1759C47.581 36.3077 51.4712 34.6963 55.5276 34.6963Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_850_4209",
    x: 0.151122,
    y: 0.151122,
    width: 126.52,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_850_4209"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_850_4209"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_850_4209",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCase4);
export default __webpack_public_path__ + "static/media/TeamCase4.d7601d15c9570dfb12138956619a98e4.svg";
export { ForwardRef as ReactComponent };